/* eslint-disable camelcase */
/**
 * Generalized async job status types and utilities
 *
 * This module provides shared types for async job status tracking across the application.
 * It eliminates duplicative code between different async job implementations.
 */

/**
 * Standard async job status values
 */

export const AsyncJobStatus = {
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export type AsyncJobStatus = typeof AsyncJobStatus[keyof typeof AsyncJobStatus];

/**
 * Base interface for async job status responses
 *
 * This provides the common structure for all async job status responses.
 * The `data` field is generic to allow different job types to specify their own data structure.
 */
export interface AsyncJobStatusResponse<T = unknown> {
  job_id: string;
  status: AsyncJobStatus;
  started_at: string;
  completed_at?: string | null;
  failed_at?: string | null;
  error?: string | null;
  data: T | null;
}
